import { ZodError, z } from "zod";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import {
  personalDataSelector,
  setCorrectStep,
  setPersonalDataErrors,
} from "@/domains/createCharacter/slice";

export default () => {
  const { t } = useTranslation("validation");
  const dispatch = useAppDispatch();
  const personalData = useAppSelector(personalDataSelector);

  const schema = useMemo(
    () =>
      z.object({
        firstName: z
          .string({ required_error: t("isRequired") })
          .min(2, t("validation.minLength", { length: 2 }))
          .max(10, t("validation.maxLength", { length: 10 })),
        lastName: z
          .string({ required_error: t("isRequired") })
          .min(2, t("validation.minLength", { length: 2 }))
          .max(10, t("validation.maxLength", { length: 10 })),
        age: z
          .number({ required_error: t("isRequired") })
          .min(18, t("validation.minAge", { age: 18 }))
          .max(99, t("validation.maxAge", { age: 99 })),
      }),
    [],
  );

  useEffect(() => {
    try {
      dispatch(setPersonalDataErrors());
      dispatch(setCorrectStep({ step: 0, isCorrect: true }));
      schema.parse(personalData);
    } catch (e) {
      if (e instanceof ZodError) {
        dispatch(setPersonalDataErrors(e.errors));
        dispatch(setCorrectStep({ step: 0, isCorrect: false }));
      }
    }
  }, [personalData]);
};
